<div class="data-validation-messages">
  <div class="data-validation-error-header">
    <mat-icon class="header-icon warning">error_outline</mat-icon>
    <h2 class="mat-h2">Data validation warnings</h2>
  </div>
  @if ((fileUploadResultsLoading$ | async) && isPanel) {
    <div class="download-progress">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <span>Retrieving latest warnings</span>
    </div>
  }
  @if (loaded) {
    <div>
      @if (!validationIsOpen) {
        <p>
          The system identified
          <span class="bold-italics">{{ warningCountMessage }}</span
          >.
          @if (!errors) {
            <span
              >Your data was successfully aggregated into FPAR tables, but
              invalid values were excluded from table counts.</span
            >
          }
        </p>
        @if (!errors) {
          <p>
            Please review these warnings to determine if they require
            remediation. If your data are correct, you may proceed.
          </p>
        }
      } @else {
        <p>
          FPAR has validated your data and found
          <span class="bold-italics">{{ warningCountMessage }}</span
          >. You can download a file of validation warnings, fix your data and
          resubmit a new file.
        </p>
      }
      <div class="data-validation-warning-messages">
        <h3>List of data warnings</h3>
        @for (warningType of warnings; track warningType) {
          <div>
            <p>{{ warningType.type }} data warnings:</p>
            <ul>
              @for (message of warningType.messages; track message) {
                <li>
                  {{ message }}
                </li>
              }
            </ul>
          </div>
        }
        <button
          class="export"
          [color]="exportButtonClass"
          mat-flat-button
          (click)="exportWarnings()"
        >
          Export Warnings
        </button>
        @if (isPanel) {
          <button class="close" color="white" mat-flat-button (click)="close()">
            Close
          </button>
        }
      </div>
    </div>
  }
</div>
